// extracted by mini-css-extract-plugin
export var chorus = "Lyrics-module--chorus--b6IxJ";
export var intro = "Lyrics-module--intro--UnhVo";
export var lyrics = "Lyrics-module--lyrics--kvHTe";
export var verse = "Lyrics-module--verse--JDuAu";